import{jsx as r}from"react/jsx-runtime";import{styled as e}from"styled-components";import{MessageList as n}from"../styles/style.mjs";const t=e.li`
  margin-left: 20px;
  color: #ee4400;
  list-style: url('images/warning_anim.png');
`;function o({errors:e}){return r(n,{className:"error",children:e.map(((e,n)=>r(t,{children:r("span",{children:e})},n)))})}export{o as ErrorList};
